export const adminUser = {
  id: 'admin-001',
  name: '김관리자',
  email: 'admin@difan.co.kr',
  role: 'SUPER_ADMIN',
}

export const dashboardMetrics = [
  { key: 'review', label: '디렉터 심사 대기', value: 12, delta: '+3 오늘', tone: 'orange' },
  { key: 'requests', label: '신규 견적 요청', value: 38, delta: '+11 오늘', tone: 'gold' },
  { key: 'payments', label: '결제 완료', value: '₩18.42M', delta: '27건', tone: 'green' },
  { key: 'settlement', label: '정산 예정', value: '₩12.97M', delta: '15명', tone: 'blue' },
]

export const directors = [
  {
    id: 'director-001',
    brandName: '스튜디오 빛결',
    representativeName: '김민지',
    email: 'hello@bitgyeol.kr',
    phone: '010-2456-7721',
    status: 'UNDER_REVIEW',
    businessStatus: 'VERIFIED',
    categories: ['생일 카페', '공간 연출', '플라워 / 오브제'],
    regions: ['서울', '경기'],
    shortHeadline: '공간의 분위기와 팬의 마음을 섬세하게 연결합니다.',
    joinedAt: '2026-08-09T15:20:00+09:00',
    reviewRequestedAt: '2026-08-10T09:13:00+09:00',
    portfolioCount: 14,
    quoteCount: 31,
    completedProjectCount: 19,
    reviewScore: 4.9,
    business: {
      registrationNo: '123-45-67890',
      legalName: '스튜디오 빛결',
      ownerName: '김민지',
      address: '서울특별시 마포구 월드컵북로 00',
      documentName: '사업자등록증_스튜디오빛결.pdf',
    },
    profile: {
      introduction: '생일 카페, 팬미팅, 전시 공간을 중심으로 플라워와 오브제, 그래픽 요소를 함께 기획합니다. 팬이 기억하고 싶은 장면을 실제 공간 안에서 자연스럽게 구현하는 것을 중요하게 생각합니다.',
      process: ['상담 및 요청서 검토', '컨셉 제안', '세부 견적 및 시안', '제작·설치', '현장 마감 및 철거'],
      consultationHours: '평일 10:00 ~ 19:00',
      preparationPeriod: '최소 3주 권장',
      onsiteConsultation: '사전 예약 시 가능',
      travelPolicy: '서울·경기 및 인접 지역 협의 가능',
      parking: '현장별 협의',
    },
    aiProfile: {
      status: 'READY',
      model: 'gpt-5-mini-snapshot',
      promptVersion: 'director-profile-v0.3',
      analyzedAt: '2026-08-10T09:18:00+09:00',
      specialties: ['고급 생일 카페', '플라워 오브제', '포토존', '웜화이트 공간'],
      moods: ['ELEGANT', 'WARM', 'CLEAN'],
      strengths: ['공간 전체 톤 통일', '플라워와 그래픽 조합', '중소형 공간 효율화'],
      caution: '대형 구조물 제작은 협력업체 일정 확인 필요',
      confidence: 0.92,
    },
  },
  {
    id: 'director-002', brandName: '모먼트 플랜', representativeName: '박수연', email: 'hello@momentplan.kr', phone: '010-3382-9911', status: 'REVIEW_REQUESTED', businessStatus: 'VERIFIED', categories: ['팬미팅 서포트', '굿즈 / 패키징'], regions: ['서울', '인천'], shortHeadline: '행사 흐름과 팬 경험을 함께 설계합니다.', joinedAt: '2026-08-08T12:00:00+09:00', reviewRequestedAt: '2026-08-10T08:02:00+09:00', portfolioCount: 8, quoteCount: 12, completedProjectCount: 5, reviewScore: 4.8,
  },
  {
    id: 'director-003', brandName: '어라운드 데이', representativeName: '이서현', email: 'around@example.com', phone: '010-9912-3044', status: 'APPROVED', businessStatus: 'VERIFIED', categories: ['광고 서포트', '전시 / 팝업'], regions: ['서울', '부산'], shortHeadline: '도시 속 팬 프로젝트를 선명한 장면으로 만듭니다.', joinedAt: '2026-07-20T11:00:00+09:00', approvedAt: '2026-07-22T15:30:00+09:00', portfolioCount: 21, quoteCount: 47, completedProjectCount: 28, reviewScore: 4.7,
  },
  {
    id: 'director-004', brandName: '오브젝트룸', representativeName: '정다은', email: 'object@example.com', phone: '010-2281-7774', status: 'SUSPENDED', businessStatus: 'VERIFIED', categories: ['플라워 / 오브제', '공간 연출'], regions: ['대구', '경북'], shortHeadline: '오브제 중심의 감각적인 공간을 만듭니다.', joinedAt: '2026-06-18T09:30:00+09:00', portfolioCount: 17, quoteCount: 24, completedProjectCount: 14, reviewScore: 4.5,
  },
]

export const quoteRequests = [
  {
    id: 'qr-001', requestNo: 'DF-QR-20260810-001', customer: { id: 'user-001', name: '김하린', nickname: '하린팬', email: 'halin@example.com' }, status: 'DISTRIBUTED', supportType: '생일 카페', artist: '하린 생일 카페', eventDate: '2026-10-18', region: '서울 성수동', budgetMin: 1200000, budgetMax: 1700000, submittedAt: '2026-08-10T09:06:00+09:00', quoteCount: 2, distributedDirectorCount: 5,
    originalRequest: '10월 중순 성수동에서 생일 카페를 준비하고 있어요. 전체적으로 밝고 고급스러운 느낌이었으면 좋겠고 메인 포토존과 플라워 장식, 테이블 오브제까지 같이 맡기고 싶어요. 너무 붉거나 화려한 느낌은 피하고 싶습니다.',
    structured: {
      categories: ['생일 카페', '공간 연출', '플라워 / 오브제'],
      moods: ['CLEAN', 'ELEGANT', 'WARM'],
      mustHaves: ['메인 포토존', '플라워 장식', '테이블 오브제'],
      avoid: ['붉은 톤', '과한 장식'],
      missing: ['정확한 공간 면적', '설치 가능 시간'],
      confidence: 0.94,
      model: 'gpt-5-nano-snapshot',
      promptVersion: 'quote-structure-v0.4',
    },
    curation: [
      { directorId: 'director-001', brandName: '스튜디오 빛결', score: 94, reasons: ['서비스 분야 일치', '서울 활동 가능', '유사한 포트폴리오 보유'], vectorScore: 0.91 },
      { directorId: 'director-003', brandName: '어라운드 데이', score: 88, reasons: ['공간 연출 경험', '서울 진행 가능'], vectorScore: 0.84 },
      { directorId: 'director-002', brandName: '모먼트 플랜', score: 82, reasons: ['행사 운영 경험', '예산 범위 유사'], vectorScore: 0.78 },
    ],
  },
  { id: 'qr-002', requestNo: 'DF-QR-20260810-002', customer: { name: '박서연', nickname: '서연데이' }, status: 'RECEIVING_QUOTES', supportType: '팬미팅 서포트', artist: '데뷔 5주년 팬미팅', eventDate: '2026-09-26', region: '서울 강남', budgetMin: 2000000, budgetMax: 3000000, submittedAt: '2026-08-10T08:40:00+09:00', quoteCount: 3, distributedDirectorCount: 6 },
  { id: 'qr-003', requestNo: 'DF-QR-20260809-017', customer: { name: '이유진', nickname: '유진픽' }, status: 'ANALYZED', supportType: '광고 서포트', artist: '컴백 전광판 광고', eventDate: '2026-09-12', region: '서울 홍대', budgetMin: 800000, budgetMax: 1200000, submittedAt: '2026-08-09T21:12:00+09:00', quoteCount: 0, distributedDirectorCount: 0 },
  { id: 'qr-004', requestNo: 'DF-QR-20260809-014', customer: { name: '최윤아', nickname: '윤슬팬' }, status: 'SELECTED', supportType: '포토존', artist: '콘서트 포토존', eventDate: '2026-09-03', region: '인천', budgetMin: 1000000, budgetMax: 1500000, submittedAt: '2026-08-09T18:20:00+09:00', quoteCount: 4, distributedDirectorCount: 5 },
]

export const payments = [
  { id: 'pay-001', paymentNo: 'DF-PAY-20260810-0041', orderNo: 'DF-ORD-20260810-0018', customer: '김하린', director: '스튜디오 빛결', amount: 1580000, status: 'PAID', method: '카드', pg: '토스페이먼츠', portonePaymentId: 'pay_difan_20260810_0041', transactionId: 'txn_01J5X9K2AB', paidAt: '2026-08-10T10:22:00+09:00' },
  { id: 'pay-002', paymentNo: 'DF-PAY-20260810-0040', orderNo: 'DF-ORD-20260810-0017', customer: '박서연', director: '모먼트 플랜', amount: 2340000, status: 'PAID', method: '카드', pg: 'KG이니시스', portonePaymentId: 'pay_difan_20260810_0040', transactionId: 'txn_01J5X8A41C', paidAt: '2026-08-10T09:11:00+09:00' },
  { id: 'pay-003', paymentNo: 'DF-PAY-20260809-0038', orderNo: 'DF-ORD-20260809-0015', customer: '정민아', director: '어라운드 데이', amount: 980000, status: 'PARTIALLY_REFUNDED', method: '카드', pg: '토스페이먼츠', portonePaymentId: 'pay_difan_20260809_0038', transactionId: 'txn_01J5WRP991', paidAt: '2026-08-09T17:42:00+09:00', refundedAmount: 180000 },
]

export const settlementBatches = [
  { id: 'set-batch-202608-02', batchNo: '2026-08-2차', period: '2026.08.08 ~ 2026.08.14', payableAt: '2026-08-20', status: 'UNDER_REVIEW', directorCount: 15, grossAmount: 13480000, pgFeeAmount: 510300, platformFeeAmount: 0, adjustmentAmount: 0, payoutAmount: 12969700 },
  { id: 'set-batch-202608-01', batchNo: '2026-08-1차', period: '2026.08.01 ~ 2026.08.07', payableAt: '2026-08-13', status: 'PAYABLE', directorCount: 11, grossAmount: 9840000, pgFeeAmount: 371900, platformFeeAmount: 0, adjustmentAmount: -50000, payoutAmount: 9418100 },
  { id: 'set-batch-202607-04', batchNo: '2026-07-4차', period: '2026.07.22 ~ 2026.07.31', payableAt: '2026-08-06', status: 'PAID', directorCount: 18, grossAmount: 16320000, pgFeeAmount: 618200, platformFeeAmount: 0, adjustmentAmount: 30000, payoutAmount: 15731800 },
]

export const aiUsage = {
  summary: {
    requestsToday: 1248,
    costTodayUsd: 19.42,
    averageQuoteAnalysisKrw: 7.8,
    averageMockupKrw: 192.4,
    failureRate: 1.8,
    cacheHitRate: 64.2,
  },
  features: [
    { key: 'QUOTE_STRUCTURE', label: '견적 요청 구조화', calls: 890, model: 'gpt-5-nano-snapshot', inputTokens: 412400, cachedTokens: 271300, outputTokens: 61900, costUsd: 3.18, latencyMs: 720, failureRate: 0.8 },
    { key: 'DIRECTOR_PROFILE', label: '디렉터/포트폴리오 분석', calls: 74, model: 'gpt-5-mini-snapshot', inputTokens: 298200, cachedTokens: 148000, outputTokens: 52300, costUsd: 4.62, latencyMs: 1640, failureRate: 1.4 },
    { key: 'CURATION_RERANK', label: '큐레이션 GPT 재정렬', calls: 46, model: 'gpt-5-mini-snapshot', inputTokens: 111600, cachedTokens: 82200, outputTokens: 18400, costUsd: 1.21, latencyMs: 1080, failureRate: 1.1 },
    { key: 'MOCKUP_PROMPT', label: '시안 프롬프트 생성', calls: 91, model: 'gpt-5-nano-snapshot', inputTokens: 76400, cachedTokens: 46300, outputTokens: 22100, costUsd: 0.64, latencyMs: 660, failureRate: 0.9 },
    { key: 'MOCKUP_IMAGE', label: 'AI 시안 이미지', calls: 147, model: 'gpt-image-2-snapshot', imageCount: 147, costUsd: 9.77, latencyMs: 11900, failureRate: 4.1 },
  ],
  modelConfigs: [
    { feature: '견적 구조화', model: 'gpt-5-nano-snapshot', prompt: 'quote-structure-v0.4', enabled: true, fallback: '규칙 기반', budget: '$8/day' },
    { feature: '포트폴리오 분석', model: 'gpt-5-mini-snapshot', prompt: 'portfolio-analysis-v0.3', enabled: true, fallback: '재시도 1회', budget: '$10/day' },
    { feature: '큐레이션 GPT rerank', model: 'gpt-5-mini-snapshot', prompt: 'curation-rerank-v0.2', enabled: false, fallback: 'Hybrid score', budget: '$5/day' },
    { feature: 'AI 시안 이미지', model: 'gpt-image-2-snapshot', prompt: 'mockup-image-v0.2', enabled: true, fallback: '수동 시안', budget: '$40/day' },
  ],
}

export const activityFeed = [
  { time: '10:34', type: 'PAYMENT', title: '결제 완료', body: 'DF-PAY-20260810-0041 · 1,580,000원' },
  { time: '10:18', type: 'DIRECTOR', title: '디렉터 심사 요청', body: '모먼트 플랜 · 사업자 인증 완료' },
  { time: '09:46', type: 'AI', title: 'AI 분석 fallback 발생', body: '견적 요청 DF-QR-20260810-001 · 규칙 기반 매칭 정상 처리' },
  { time: '09:13', type: 'DIRECTOR', title: '디렉터 심사 요청', body: '스튜디오 빛결 · 포트폴리오 14건' },
  { time: '08:52', type: 'SETTLEMENT', title: '정산 회차 검토 시작', body: '2026-08-2차 · 15명' },
]
